// extracted by mini-css-extract-plugin
module.exports = {"toc":"TableOfContents-module__toc___1Toq1","active":"TableOfContents-module__active___3h6Vx","sublevel":"TableOfContents-module__sublevel___AYuGE"};